import type React from 'react';

export type TickCellHeader = {
  title: string;
  EXCELLENT: React.ReactNode;
  VERY_GOOD: React.ReactNode;
  SATISFACTORY: React.ReactNode;
  AVERAGE_OR_BELOW: React.ReactNode;
  NO_BASIS_FOR_JUDGMENT: React.ReactNode;
};

export type ApplicantInformation = {
  nameOfApplicant: string;
  department: string;
  programme: string;
  researchArea: string;
  [key: string]: string;
};

export type RefereeInformation = {
  nameOfReferee: string;
  institution: string;
  position: string;
  email: string;
  telephoneNumber: string;
  faxNumber: string;
  address: string;
  [key: string]: string;
};

export enum RecommendationLevel {
  VERY_HIGHLY_RECOMMENDED = 'VERY_HIGHLY_RECOMMENDED',
  HIGHLY_RECOMMENDED = 'HIGHLY_RECOMMENDED',
  RECOMMENDED = 'RECOMMENDED',
  NOT_RECOMMENDED = 'NOT_RECOMMENDED',
}

export type RefereeStatusType = {
  name: string;
  title: string;
  email: string;
  status: RefereeStatus;
  lastSentDate: Date;
  replyDate?: Date;
};

export enum RefereeStatus {
  PENDING = 'PENDING',
  REPLIED = 'REPLIED',
  OVERDUE = 'OVERDUE',
  SUBMITTED = 'SUBMITTED',
}

export type ApplicationInformation = ApplicantInformation & RefereeInformation;
